/**
 * Normalises an untrusted post-auth redirect target to a same-origin path.
 *
 * Anything that could resolve to a foreign origin collapses to "/". The
 * backslash normalisation is the load-bearing part: browsers treat "\" as "/"
 * in URL authority position, so "/\evil.com" and "\\evil.com" navigate
 * off-origin even though a naive startsWith("/") check passes them. That exact
 * bypass is GHSA-wrjc-x8rr-h8h6 (CVE-2025-68470 bypass) — this guard closes it
 * at the application layer so the behaviour does not depend on which
 * react-router version is installed.
 */
export function toInternalPath(raw: string | null | undefined): string {
  if (!raw) return "/";

  // Strip TAB/LF/CR first: browsers remove them from URLs *before* parsing, so
  // "/\t/evil.com" would pass a naive check here and only then collapse to the
  // protocol-relative "//evil.com". Validate what the browser will resolve.
  const value = raw.replace(/[\t\n\r]/g, "").replace(/\\/g, "/");

  // Must be a single-slash absolute path. Rejects protocol-relative ("//host"),
  // absolute URLs ("https://host"), and scheme-like values ("javascript:...").
  if (!value.startsWith("/") || value.startsWith("//")) return "/";

  return value;
}
